import React from 'react';
import PropTypes from 'prop-types';
import clsx from 'clsx';
import { makeStyles } from '@mui/styles';
import { Grid } from '@mui/material';

import { Picture, Details } from './components';

const useStyles = makeStyles((theme) => ({
	root: {},
	deliverables: {
		marginTop: theme.spacing(3),
	},
	members: {
		marginTop: theme.spacing(3),
	},
}));

const Overview = (props) => {
	const { operator, className, ...rest } = props;

	const classes = useStyles();

	return (
		<Grid
			{...rest}
			className={clsx(classes.root, className)}
			container
			spacing={3}
		>
			<Grid item lg={4} md={6} xl={3} xs={12}>
				<Picture operator={operator} />
			</Grid>
			<Grid item lg={8} md={6} xl={9} xs={12}>
				<Details operator={operator} />
			</Grid>
		</Grid>
	);
};

Overview.propTypes = {
	className: PropTypes.string,
	operator: PropTypes.object.isRequired,
};

export default Overview;
